import { AdminRunReconciliation } from 'src/constants/actionTypes'
import type { ReconciliationRun } from 'src/interfaces/reconciliation'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { ReconciliationState } from './types'

const getInitialState = (): ReconciliationState => {
  return { lastRun: null, running: false, error: null }
}

export const reconciliationReducer = (
  state: ReconciliationState = getInitialState(),
  action: Action<unknown>,
): ReconciliationState => {
  switch (action.type) {
    // A stale result next to a running request would read as the new answer — clear it.
    case AdminRunReconciliation.type.REQUEST:
      return { lastRun: null, running: true, error: null }
    case AdminRunReconciliation.type.SUCCESS:
      return {
        lastRun: (action.payload as ReconciliationRun | undefined) ?? null,
        running: false,
        error: null,
      }
    case AdminRunReconciliation.type.FAILED:
      return {
        ...state,
        running: false,
        error: resolveErrorMessage(action.payload, 'Reconciliation failed'),
      }

    default:
      return state
  }
}
